import { registerSymbol } from "library/serialize-circular.mjs"
const PlanRoot = registerSymbol(Symbol("PlanRoot"))
export { PlanRoot }
